import { SvgIcon, SvgIconProps } from '@mui/material';


export interface CcfInsertIconProps extends SvgIconProps {
  fillColor?: string;
}
/**
 * Component displays Insert Icon
 * @param props -SvgIconProps
 * @returns insert svg icon
 * @example <CcfInsertIcon/>
 */
export function CcfInsertIcon(props: CcfInsertIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M2 18C1.45 18 0.979002 17.804 0.587002 17.412C0.195002 17.02 -0.000664969 16.5493 1.69779e-06 16V2C1.69779e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06H11V2H2V16H16V7H18V16C18 16.55 17.804 17.021 17.412 17.413C17.02 17.805 16.5493 18.0007 16 18H2ZM5 14V12H13V14H5ZM5 11V9H13V11H5ZM5 8V6H13V8H5ZM14 6V4H12V2H14V1.69779e-06H16V2H18V4H16V6H14Z" 
          fill={props.fillColor ? props.fillColor : '#333333'}
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfInsertIcon;
